import { render, staticRenderFns } from "./ProductsMain.vue?vue&type=template&id=77e7718a&scoped=true&"
import script from "./ProductsMain.vue?vue&type=script&lang=js&"
export * from "./ProductsMain.vue?vue&type=script&lang=js&"
import style0 from "./ProductsMain.vue?vue&type=style&index=0&id=77e7718a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e7718a",
  null
  
)

export default component.exports